import { Model } from '../../api/model';

export class SettingModel extends Model {

    public type: string;

    public name: string;

    public value: any;

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/settings/models/setting.model.ts